import { Popover } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useRef, useState } from 'react';

import SideButton from '@components/SideStripDesktop/SideButton';

import { useIsMobile } from '@hooks/useIsMobile';

import CurationStats from './CurationStats';

export default function CurationCard() {
  const anchorBtnRef = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const toggleCard = () => setIsOpen(!isOpen);

  const mobile = useIsMobile('md');

  const children = <CurationStats />;

  const { palette } = useTheme();

  return mobile ? (
    <>
      <SideButton
        color={palette.primary.main}
        iconName="ellipsis-vertical"
        iconType="fas"
        onClick={toggleCard}
        ref={anchorBtnRef}
        showTooltip={false}
      />
      <Popover
        anchorEl={anchorBtnRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        onClose={handleClose}
        open={isOpen}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              backgroundColor: 'grey.300',
            },
          },
        }}
      >
        {children}
      </Popover>
    </>
  ) : (
    children
  );
}
